<template>
  <div>
    <basic-container>
      <div>
        <!-- 搜索栏 -->
        <div>
          <el-input
            clearable
            v-model="searchParams.name"
            placeholder="Push模板标题"
            size="small"
            style="width: 250px; margin-right: 20px"
          ></el-input>
        </div>
        <!-- 搜索控件 -->
        <div style="margin-top: 20px; margin-bottom: 20px">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            v-auth="'ACTIVE-PUSH-MANAGE-SEARCH'"
            @click="search"
            >搜索</el-button
          >
          <el-button
            v-auth="'ACTIVE-PUSH-MANAGE-ADD'"
            size="small"
            icon="el-icon-plus"
            @click="add"
            >新增</el-button
          >
          <el-button
            v-auth="'ACTIVE-PUSH-MANAGE-DELS'"
            size="small"
            type="danger"
            icon="el-icon-del"
            @click="batchDel"
            >删除</el-button
          >
        </div>
        <!-- 表格 -->
        <el-table
          border
          ref="table"
          :data="list"
          @select="select"
          @select-all="selectAll"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="id"
            label="Push模板ID"
            width="300"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="Push模板标题"
            width="300"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-auth="'ACTIVE-PUSH-MANAGE-VIEW'"
                icon="el-icon-view"
                type="text"
                size="small"
                @click="view(scope.row)"
                >查看</el-button
              >
              <el-button
                v-auth="'ACTIVE-PUSH-MANAGE-EDIT'"
                icon="el-icon-edit"
                type="text"
                size="small"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-auth="'ACTIVE-PUSH-MANAGE-DEL'"
                icon="el-icon-delete"
                type="text"
                size="small"
                @click="del(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <ElementPagination
          style="margin-bottom: 20px"
          :current-page="searchParams.current"
          :page-size="searchParams.size"
          :total="searchParams.total"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <AddDialog
        ref="addDialog"
        @reload="
          () => {
            this.loadList();
          }
        "
      ></AddDialog>
    </basic-container>
  </div>
</template>

<script>
import ElementPagination from "@/components/ElementPagination";
import AddDialog from "./components/add.vue";
import Message from "@/components/Message";
import { getPushList, deletePush } from "@/api/runActivityManage/pushManage";
export default {
  name: "WebSassIndex",
  components: {
    ElementPagination,
    AddDialog,
  },
  data() {
    return {
      /** 存储选中的列表 */
      selectedList: [],
      searchParams: {
        name: "",
        current: 1,
        size: 10,
        total: 50,
      },
      /** push列表 */
      list: [],
    };
  },
  created() {
    /** 初始化数据 */
    this.loadList();
  },
  methods: {
    /** 批量删除 */
    batchDel() {
      const length = this.selectedList.length;
      if (length === 0) {
        Message.error("请至少选择一条需要删除的数据");
        return;
      }
      /** 二次询问 */
      this.$confirm(`是否确认批量删除${length}条数据？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const ids = this.selectedList.map((item) => item.id);
          /** 确认删除 */
          const { data } = await deletePush(ids.join(","));
          console.log("删除的响应", data);
          if (data.code === 200) {
            Message.success("删除成功");
            this.loadList();
            /** 清空选择的列表 */
            this.selectedList = [];
          }
        })
        .catch(() => {});
    },
    /** 新增的事件 */
    add() {
      this.$refs.addDialog.show("创建Push", false);
    },
    //^ ^--------------表格内的事件-------------^ ^
    /** 选择 */
    select(selection, row) {
      console.log(selection, row);
      /** 判断row是否存在selectedList里面 */
      const index = this.selectedList.findIndex((item) => item.id === row.id);
      if (index === -1) {
        /** 不存在 */
        this.selectedList.push(row);
      } else {
        /** 存在 */
        this.selectedList.splice(index, 1);
      }
    },
    /** 全选 */
    selectAll(selection) {
      console.log(selection);
      this.selectedList = [...(selection || [])];
    },
    //^ ^--------------操作栏的事件-------------^ ^
    /** 查看 */
    view(row) {
      console.log(row);
      this.$refs.addDialog.show("查看", true, row);
    },
    /** 编辑 */
    edit(row) {
      console.log(row);
      this.$refs.addDialog.show("编辑", false, row);
    },
    /** 删除 */
    del(row) {
      console.log(row);
      /** 二次询问 */
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          /** 确认删除 */
          const { data } = await deletePush(row.id);
          console.log("删除的响应", data);
          if (data.code === 200) {
            Message.success("删除成功");
            /** 从已选择的列表也要去除 */
            const index = this.selectedList.findIndex(
              (item) => item.id === row.id
            );
            if (index !== -1) {
              this.selectedList.splice(index, 1);
            }
            this.loadList();
          }
        })
        .catch(() => {});
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索的事件 */
    search() {
      /** 重置分页 */
      this.searchParams.current = 1;
      /** 更新数据 */
      this.loadList();
      Message.success("搜索成功");
    },
    async loadList() {
      const { data } = await getPushList(this.searchParams);
      console.log("获取push列表", data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
      /** 回填选中的数据 */
      this.$nextTick(() => {
        this.selectedList.forEach((item) => {
          const index = this.list.findIndex((row) => row.id === item.id);
          this.$refs.table.toggleRowSelection(this.list[index], true);
        });
      });
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 模拟分页 */
      this.list = this.list.slice(
        (val - 1) * this.searchParams.size,
        val * this.searchParams.size
      );
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>